module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Home":"Home","Life Individual":"Life Individual","Life Group":"Life Group"},"fr":{"Home":"Habitation","Life Individual":"Vie individuel","Life Group":"Vie collectif"}}')
  delete Component.options._Ctor
}
